import {otherKey, presentText} from '@Components/ai-chat-window/components/survey/survey.library';
import type {MultiSelectField} from '@Components/ai-chat-window/components/survey/survey.types';

export function toggleValue(current: string[], value: string): string[] {
  if (current.includes(value)) {
    return current.filter((entry) => entry !== value);
  }

  return [...current, value];
}

export function countSelections(value: unknown, otherValue: unknown): number {
  let count = 0;

  if (Array.isArray(value)) {
    count = value.length;
  }

  if (presentText(otherValue) !== undefined) {
    count += 1;
  }

  return count;
}

export function buildMultiSelectValidator(field: MultiSelectField, name: string): (value: unknown, formValues: Record<string, unknown>) => true | string {
  return (value: unknown, formValues: Record<string, unknown>): true | string => {
    const selectedCount = countSelections(value, formValues[otherKey(name)]);
    const isBelowMin = typeof field.min === 'number' && selectedCount < field.min;
    const isAboveMax = typeof field.max === 'number' && selectedCount > field.max;

    if (isBelowMin) {
      return window.i18next.t('pmwjs_survey_select_at_least_x', {count: field.min});
    }

    if (isAboveMax) {
      return window.i18next.t('pmwjs_survey_select_at_most_x', {count: field.max});
    }

    return true;
  };
}
